import storageNamespace from "../util/data.js";
import { namespace, defaults, noExport, exportTransforms, importTransforms } from "../config.js";
import { initQuery } from "../util/query.js";

const storage = storageNamespace(namespace, defaults);

if (initQuery.data) {
	if (confirm("Would you like to import your Celtix data from your other device? This will overwrite any data you have stored on this device."))
		storage.import(initQuery.data, importTransforms);
	location.search = '';
}

document.getElementById('export-data-button').addEventListener('click', () => {
	const url = `${location.origin}${location.pathname}?data=${storage.export(noExport, exportTransforms)}`;
	document.getElementById('export-data-link').setAttribute('href', url);
	document.getElementById('export-data-qr').innerHTML = '';
	try {
		new QRCode(document.getElementById('export-data-qr'), { text: url, width: 1024, height: 1024 });
		document.getElementById('export-data-qr-worked').classList.remove('hidden');
	} catch (e) {
		console.log('Too much data for QR code');
		document.getElementById('export-data-qr-worked').classList.add('hidden');
	}
});

document.getElementById('confirm-delete-data').addEventListener('click', async () => {
	storage.clear();
	location.reload();
});

export default storage;
